import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import {
  QueryClient,
  QueryClientProvider,
  HydrationBoundary,
  type DehydratedState,
} from '@tanstack/react-query';
import { ErrorBoundary, ToastProvider } from '@yingbaba/ui';
import '@yingbaba/tokens/style.css';
import { websiteRoutes } from './routes';
declare global {
  interface Window {
    __REACT_QUERY_STATE__?: DehydratedState;
  }
}
const query = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, retry: 1 } } });
const router = createBrowserRouter(websiteRoutes);
const tree = (
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={query}>
        <HydrationBoundary state={window.__REACT_QUERY_STATE__}>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </HydrationBoundary>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
const root = document.getElementById('root')!;
// Vite's client-only shell contains <!--app-->, not actual SSR markup.
if (root.childElementCount > 0) hydrateRoot(root, tree);
else createRoot(root).render(tree);
